/*
	these tools functions are very useful for force-reformatting
	the content type of input fields, displaying better fee estimations, etc
*/
import path from 'path';

// TODO move this to storybook
export const devMode_fake_paths = ["fakefilepath1.json", "fakefilepath2.json"]

export const devMode_fake_walletBackups = []

/**
 * returns all files path in the cache for a search term
 */
export function get_all_files_paths_from_cache(search_term = "_walletBackup") {
	const function_id = "tools.js: get_all_files_paths_from_cache(): "
	const log = getLog(function_id)

	const isDevMode = !isElectron()
	if (isDevMode) return devMode_fake_paths

	var file_paths = [] // default return value

	try {
		// console.log(function_id,"app = ",app)
		// const defaultCwd = app.getPath('userData');
		const defaultCwd = window.electron.getAppGetPath('userData')
		log("defaultCwd =", defaultCwd)

		const cacheFolder = path.join(defaultCwd, "WalletHistoryCache") //defaultCwd+"/WalletHistoryCache/"
		log("cacheFolder =", cacheFolder)

		file_paths = window.electron.fsReadDirSync(cacheFolder)
		file_paths = file_paths.filter(e => e.includes(search_term)) // we filter only the wallet backups
		file_paths = file_paths.filter(e => e.length > (search_term + ".json").length + 1) // safety check
		log("AFTER FS READ DIR & filter, files =", file_paths)
	}
	catch (e) {
		console.error(function_id, "error getting wallet backups ", e)
		return file_paths
	}
	return file_paths
}

/**
 * filter a dict to remove the functions from it, making it loggable
 * we also display only arrays length if the arrays contain objects
 */
export function dictFilterFuncs(d) {
	let d2 = {}
	let keys = Object.keys(d)
	for (let i = 0; i < keys.length; i++) {
		let key = keys[i]
		if (typeof (d[key]) === "object") {
			let array = d[key]
			if (array && array.length > 0 && typeof (array[0]) === "object") {
				d2[key] = "[array of objects of length " + array.length + "]"
			} else {
				d2[key] = array
			}
		} else if (typeof (d[key]) !== "function") {
			d2[key] = d[key]
		}
	}
	return d2
}

/**
 * usage:
 * 		tryAccessProperty(() => user.address.postcode) // return postcode or undefined
 * 		tryAccessProperty(() => user.address.postcode, "none") // return postcode or a custom string
 * 
 * BEWARE OF THE "Function declared in a loop contains unsafe references to variable(s)..."
 * 		this creates grave bugs, check https://eslint.org/docs/rules/no-loop-func
 * 		basically: only pass "let" or const" variables, never "var" variables that are unsafe because of their wider scope
 */
export function tryAccessProperty(func, fallbackValue) {
	try {
		var value = func();
		return (value === null || value === undefined) ? fallbackValue : value;
	} catch (e) {
		return fallbackValue;
	}
}

/**
	Will return true for: 0, 1, 2, 3.365655, ...
	false for: NaN, undefined, null, Infinity, "hello", "3.3565"...
*/
export function isNumber(val) {
	return Number.isFinite(val)
}

// for an array of objects with "status" that can be "pending" and a "timestamp" int value
// we want pending orders to always appear first
export function sort_pendings_first(table_values) {
	const function_id = "sort_pendings_first(): "
	const log = getLog(function_id)
	try {
		// TODO improve by logging everything that is a basic type (not JSX)
		log("table_values=", table_values.map((e) => {
			return {
				status: e['status'],
				timestamp: e['timestamp'],
				date: e['date'],
				nb_tokens: e['nb_tokens'],
				total_EUR_paid: e['total_EUR_paid'],
			}
		}))
	} catch (e) { console.error(function_id + e) }

	table_values.sort((a, b) => {
		let is_a_pending = !!a['status'].includes("pending")
		let is_b_pending = !!b['status'].includes("pending")
		if (is_a_pending && !is_b_pending) {
			return -1  // move a to first
		}
		else if (is_b_pending && !is_a_pending) {
			return +1  // move b to first
		}
		else if (is_a_pending && is_b_pending) {
			// check timestamps
			if (a['timestamp'] > b['timestamp']) return -1
			else return 1
		}
		else { // no one is pending, sort based on timestamp
			// check timestamps
			if (a['timestamp'] > b['timestamp']) return -1
			else return 1
		}
	})
}


// filter out functions from an obj (useful for printing React states)
export function remove_functions_from_obj(obj) {
	let res_obj = {}
	let keys = Object.keys(obj)
	for (let i = 0; i < keys.length; i++) {
		let key = keys[i]
		let val = obj[key]
		if (typeof val !== "function") {
			res_obj[key] = val
		}
	}
	return res_obj
}

/**
 * To display fee estimations.
 * Will ceil to the 2nd decimal.
 * ex: 0.012 will return 0.02
 */
export function ceil_to_2_decimals(fees_usd) {
	return parseFloat((Math.ceil(fees_usd * 100) / 100).toFixed(2))
}

/**
 * since percent fees are percent AFTER adding the fees, we need this special formula
 * ex: 100+1% = 101, -1%=99.99 and not 100 ! => we actually need 101.02 ! since 101.02-1%=100
 * @param {number} currval
 * @param {int or float} percent - between [0,100]
 */
export function get_afterPercentFee_toAdd(currval, percent, ceilto2decimals = true) {

	let to_add = (currval * percent) / (100 - percent) // verified: https://jsfiddle.net/zhell/cruaqef7/
	// we ceil to 2 decs, so that we have a little margin instead of truncating and being below
	if (ceilto2decimals) to_add = ceil_to_2_decimals(to_add)
	return to_add
}

/**
 * send a dict/obj and a list of keys to keep
 * will return the same obj but with only the keys&values for which a key is found in the keep_keys list
 */
export function partial_obj(obj, keep_keys) {
	var res_obj = {}
	for (let i = 0; i < keep_keys.length; i++) {
		if (obj.hasOwnProperty(keep_keys[i])) {
			res_obj[keep_keys[i]] = obj[keep_keys[i]]
		}
	}
	return res_obj
}

export function await_sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

function last_of_array(myarray) {
	return myarray[myarray.length - 1]
}

export function unprefix_address(address) {
	return last_of_array(address.split(':'))
}

// TODO move this to a file that isn't deprecated as its default export
/**
 * this function will analyse an error as a jsx objet or string
 * to say it is empty or not
 */
export function errorjsx_isNOTempty(errormess) {
	// beware length is undefined for JSX objects so length>0 returns false
	// also a={var:"val"}; (a==true) returns false
	if (errormess == null || errormess === "") return false
	if (typeof errormess == "string" && errormess.length > 0) return true
	if (typeof errormess == "object") return true
	if (errormess) return true
	return false
}

//better than tofixed(2) that does some rounding, this is pure truncate:
export function truncate(decimal, n = 2) {
	let x = decimal + ''; // string 
	return x.lastIndexOf('.') >= 0 ? parseFloat(x.substr(0, x.lastIndexOf('.') + (n + 1))) : decimal; // You can use indexOf() instead of lastIndexOf()
}

/**
 * "bitcoin" => "Bitcoin"
 * "bitcoinSV" => "BitcoinSV"
 */
export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

export function deleteAllSpaces(val) {
	return val.toString().replace(/ /g, '') // delete spaces
}

export function forceInt(val) {
	//on force un entier 
	val = deleteAllSpaces(val)
	if (val.length > 0) val = parseInt(val)
	return val
}

export function old_forceFloat(val, nbdecimals = 2) {
	// on force un float à X décimales
	// beware this will return a string for values like "1.0" or "1.00" ! 
	val = deleteAllSpaces(val).replace(',', '.')
	var strval = val
	if (nbdecimals > 0 && (strval === "0." || strval === '0')) return strval // special case
	var last = strval[strval.length - 1]
	if (strval.length > 2) var last2 = strval.slice(strval.length - 2, strval.length)
	if (strval.length > 3) var last3 = strval.slice(strval.length - 3, strval.length)
	if (strval.length > 0) {
		val = parseFloat(strval)
		var decimals = strval.split('.')[1]
		if (decimals && decimals.length > 2) val = truncate(val, nbdecimals)
	}
	// we make sure we can write things like 0.00, 0.01, 1.01, etc
	if (strval.length > 3 && (last3 === ",00" || last3 === ".00"))
		val += last3
	else if (strval.length > 2 && (last2 === ".0" || last2 === ",0"))
		val += last2
	else if (strval.length > 1 && (last === '.' || last === ','))
		val += last
	return val
}
// simplified version
export function forceFloat(val, nbdecimals = 2) {
	val = deleteAllSpaces(val).replace(',', '.');
	var strval = val;
	// Allow incomplete but valid numeric inputs
	if (strval === '' || strval === '-' || strval.match(/^-?\d*\.$/)) {
		return strval;
	}
	val = parseFloat(strval);
	if (isNaN(val)) return ''; // Default for invalid inputs
	var decimals = strval.split('.')[1]
	if (decimals && decimals.length > nbdecimals) val = truncate(val, nbdecimals);
	return val.toString();
}


export function isElectron() {
	if (typeof window === 'undefined') return false
	var userAgent = navigator.userAgent.toLowerCase()
	if (userAgent.indexOf(' electron/') > -1) return true
	return false
}


export function deepcopy(obj) {
	var stringified = JSON.stringify(obj)

	// this happens with 2 jigs looped one into the other for example
	if (!stringified) return "undefined"

	return JSON.parse(stringified)
}


export function removeDupsInArray(arr) {
	return arr.filter((item, index) => arr.indexOf(item) === index);
}



/**
 * give any type of timestamp (in secs or ms or even in microseconds) and this function will 
 * detect which kind it is and return it in ms
 */
export function timestamp_to_ms(timestamp) {
	const function_id = " timestamp_in_ms(): "

	const TODAY_ms = Date.now()
	const TODAY_secs = TODAY_ms / 1000
	// const TODAY_microsecs = TODAY_ms*1000
	const THOUSAND_YEARS_secs = 1000 * 365 * 24 * 60 * 60  // in seconds, margin used to compare timestamps in seconds vs milliseconds
	const THOUSAND_YEARS_ms = THOUSAND_YEARS_secs * 1000
	// const THOUSAND_YEARS_microsecs = THOUSAND_YEARS_ms*1000

	// start from highest to lowest possible value

	// start by checking if we are in micro-seconds
	if (timestamp > TODAY_ms + THOUSAND_YEARS_ms) {
		// it's in microseconds
		console.log(function_id + " timestamp " + timestamp + " is in micro-seconds, changing it to ms ")
		return timestamp / 1000
	}
	// check if in ms
	else if (timestamp > TODAY_secs + THOUSAND_YEARS_secs) {
		// it's in milliseconds, all good
		return timestamp
	}
	else {
		// it's in seconds
		console.log(function_id + " timestamp " + timestamp + " is in seconds, changing it to ms ")
		return timestamp * 1000
	}
}


export function get_explorer_url_from_txhash(txhash, network = "") {

	txhash = txhash.split('_')[0]

	var token_url = ""
	if (network === "test") {
		token_url = "https://test.whatsonchain.com/tx/" + txhash
	} else {
		token_url = "https://whatsonchain.com/tx/" + txhash
	}

	return token_url
}


export function getLog(function_id, ...setup_args) {
	// add a ':' at the end of each if not already there
	if (!function_id) function_id = "" // safety check
	if (!function_id.includes(":")) function_id += ":"
	let new_setup_args = []
	if (setup_args && setup_args.length > 0) {
		for (let i = 0; i < setup_args.length; i++) {
			let setup_arg = setup_args[i]
			if (!setup_arg.includes(":")) setup_arg += ":"
			new_setup_args.push(setup_arg)
		}
	}
	// return as a function + object
	let res = function(...args) {
		console.log(function_id, ...new_setup_args, ...args)
	}
	res.log = function(...args) {
		console.log(function_id, ...new_setup_args, ...args)
	}
	res.info = function(...args) {
		console.info(function_id, ...new_setup_args, ...args)
	}
	res.warn = function(...args) {
		console.warn(function_id, ...new_setup_args, ...args)
	}
	res.error = function(...args) {
		console.error(function_id, ...new_setup_args, ...args)
	}
	return res
}


/**
 * usage:
 *		const [function_id, log] = getLog(this.classname+"update_contract_generic():")
 *
 * to get args_dict too:
 *		const [function_id, log, args_dict] = getLog(this.classname+"update_contract_generic():", f, arguments)
 *
 * with arrow functions: convert arrow function to: 	
 *		myfunc = async function f(a,b,c) {
 * 			 const [function_id, log, args_dict] = getLog("myfunc():", f, arguments)
 *		}
 */
export function getLogArray(function_id, myfunc = null, myargs = null) {
	if ((myfunc && !myargs) || (myargs && !myfunc)) throw new Error("Requires both function & arguments or neither.")
	let args_dict = null
	if (myfunc && myargs) {
		args_dict = func_and_args_to_obj(myfunc, myargs)
	}

	const log = function(...args) {
		console.log(function_id, ...args)
	}
	return [function_id, log, args_dict]
}

/** useful for logging all args of a function as a dict
*	DOES NOT WORK WITH ARROW FUNCTION because myfunc.toString() only returns "native code"
* usage: 
*		myfunc(a,b){
* 			console.log(func_and_args_to_obj(myfunc, arguments)) // 'arguments' is a js keyword
*  		}
*		myfunc(1, "hello")
*
* will log:
*		 {"a":1, "b":"hello"}
*/
export function func_and_args_to_obj(myfunc, myargs) {
	let args_names = myfunc.toString().split('{')[0].split('(')[1].split(')')[0].split(',')
	args_names = args_names.map(e => e.trim()) // remove leading and trailing whitespaces
	// console.log("args_names=",args_names)
	var args_obj = {}
	for (let i = 0; i < args_names.length; i++) {
		args_obj[args_names[i]] = myargs[i]
	}
	return args_obj
}


// calls function fn with context self and parameters defined in dictionary namedParams
// from http://ivanzuzak.info/2009/08/09/named-arguments-in-javascript.html
/* usage:
	function callMe(param1, param2, param3) {
		// do something ...
	}
	var result = callWithNamedArgs(
		callMe, this, { 'param3' : 1, 'param1' : 2, 'param2' : 3 })
*/
export function callWithNamedArgs(fn, self, namedParams) {
	// const log = getLog("callWithNamedArgs():")

	// get string representation of function
	var fnDef = fn.toString();
	if (fnDef.includes("[native code]")) {
		throw new Error("[native code] found instead of body function, "
			+ "are you using a bound function ? swich to an arrow function to fix.")
	}

	// parse the string representation and retrieve order of parameters
	var argNames = fnDef.substring(fnDef.indexOf("(") + 1, fnDef.indexOf(")"));
	argNames = (argNames === "") ? [] : argNames.split(", ");
	var argIndexes = {};
	for (var i = 0; i < argNames.length; i++) {
		argIndexes[argNames[i]] = i;
	}
	// log("argIndexes=",argIndexes)

	function null_or_undefined(myVar) { // tests if null or undefined but not 0
		return typeof myVar === 'undefined' || myVar === null
	}

	// construct an array of arguments from a dictionary
	var callParameters = [];
	for (let paramName in namedParams) {
		// log("\n> paramName=",paramName,"=> null_or_undefined?=",null_or_undefined(argIndexes[paramName]))
		if (!null_or_undefined(argIndexes[paramName])) {
			callParameters[argIndexes[paramName]] = namedParams[paramName];
		}
	}

	// invoke function with specified context and arguments array
	// log("namedParams=",namedParams,"\n callParameters=",callParameters)
	return fn.apply(self, callParameters);
}


// Utility to filter out non-serializable values
export const filterSerializable = (obj) => {
	const filtered = {};
	for (const key in obj) {
		const value = obj[key];
		if (typeof value !== 'function' && value !== undefined) {
			// Only include plain data (no functions, no undefined)
			filtered[key] = value;
		}
	}
	return filtered;
};

// KEEP THIS IT WILL BE USEFUL 15.12.2021
// // wait with timeout for a state var to be set inside a context
// // A ref is needed for setTimeout to always have the latest value
// // but beware: a ref changing value doesn’t trigger a re-render
// // 	=> solution: state={ myvar: myvar_ref.current }
// import { retryevery_ms, tryduring_ms } from "./Contexts/UserContext/UserContext"
// const myvar_ref = useRef(null)
// const state={ myvar: myvar_ref.current }
// async function has_loaded_asyncf() {
//     // call this function with await to make sure runcraft has finished loading
//     const function_id = classname+"has_loaded_asyncf(): "
//     if (RuncraftRef.current) return RuncraftRef.current
//     var trycounter = 0
// 	return new Promise((resolve, reject) =>
//     {
//         const waitFor = async() =>
//         {
//             log("waitFor, trycounter=",trycounter,"!!Runcraft=",!!Runcraft)
//         	   trycounter += retryevery
//         	   if(trycounter > tryduring)
//             {
// 				 return reject(
// 					function_id+" timed out after "+tryduring/1000+" seconds"
// 				 )
//         	   }
//             // beware: ref needed with setTimeout !
//             if (RuncraftRef.current) return resolve(RuncraftRef.current)
//             // setTimeout in Functional components: https://upmostly.com/tutorials/settimeout-in-react-components-using-hooks
//             setTimeout(waitFor, retryevery)
//         }
//         waitFor()
//     })
// }


import React, { Fragment } from "react";
import { hasNestedProperty } from '../shared/helpers';

export function is_string(obj) {
	return (typeof obj === 'string' || obj instanceof String)
}

export function is_hex(inputString) {
	var re = /^[0-9A-Fa-f]+$/;
	return re.test(inputString)
}

export function ms_to_time(ms) {
	if (ms < 1000) return ms + "ms"
	if (ms < 1000 * 60) return (ms / 1000).toFixed(2) + "s"
	if (ms < 1000 * 60 * 60) return (ms / 1000 / 60).toFixed(2) + "mn"
	if (ms < 1000 * 60 * 60 * 24) return (ms / 1000 / 60 / 60).toFixed(2) + "hours"
	else return (ms / 1000 / 60 / 60 / 24).toFixed(2) + "days"
}

export function get_time() {
	var today = new Date();
	var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
	var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
	var dateTime = date + ' ' + time;
	return dateTime
}

export function sleep_await(ms) {
	// use with await, only for tests & debug as it will slow everything
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
}

export function mult_to_percent(val_mult) {
	return parseFloat(((parseFloat(val_mult) - 1) * 100).toFixed(6))
}

export function percent_to_mult(val_percent) {
	var val_newmult = 0
	if (val_percent > 0.0) val_newmult = 1 + val_percent / 100
	else if (val_percent <= -100.0) {
		val_percent = -100.0
		val_newmult = 0.00
	}
	else val_newmult = 1 - (-1 * val_percent) / 100
	return val_newmult
	/* // to test this function:
		const log = console.log
		to_test = [1000,200,100,50,2.35,1.35,0.35,-0.5,-1,-50,-75,-100, -200]
		log("to_test = ",to_test)

		var mults=[]
		for (let i=0; i<to_test.length;i++){
			t=to_test[i]
			//log((t>0?"+":"")+t+"%  == x"+percent_to_mult(t))
		mults.push(percent_to_mult(t))
		}
		log("mults = ",mults)

		to_test = [11, 3, 2, 1.5, 1.0235, 1.0135, 1.0035, 0.995, 0.99, 0.5, 0.25, 0, 0]
		var percs=[]
		for (let i=0; i<to_test.length;i++){
			t=to_test[i]
		percs.push( parseFloat( ((t-1)*100).toFixed(4) ) )
		}
		log("percs   = ",percs)
	*/
}

export function utf8_to_b64(str) {
	return window.btoa(unescape(encodeURIComponent(str)));
}


export function formatBytes(bytes, decimals = 2) {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	// US version:  ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const sizes = ['Bytes', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}


export async function simulate_loadingtime(timeinms) {
	//simulates a long loading & syncing time, useful
	if (timeinms > 0) {
		var wait = ms => new Promise((r, j) => setTimeout(r, ms))
		await wait(timeinms)
	}
}

export function scrollRefIntoView(myref) {
	// force scrollbar to bottom to display new important messages
	if (myref && myref.current) {
		// scrollIntoViewIfNeeded is Chrome-only; fall back to scrollIntoView for Firefox/Safari
		if (typeof myref.current.scrollIntoViewIfNeeded === "function") {
			myref.current.scrollIntoViewIfNeeded({ behavior: "smooth" })
		} else if (typeof myref.current.scrollIntoView === "function") {
			myref.current.scrollIntoView({ behavior: "smooth", block: "nearest" })
		}
	}
}


export const default_func_jsx_fail = (txstate) => {
	let url_jsx = null
	if (hasNestedProperty(txstate, "owner")) {
		const url = "https://whatsonchain.com/address/" + txstate.owner
		url_jsx =
			<a href={url} target="_blank">
				Cliquez ici pour verifier votre adresse sur un explorateur blockchain.
			</a>
	}
	return (
		<Fragment>
			Echec lors de la construction ou de l'envoi de la transaction.
			{url_jsx}
			Erreur: {txstate.error}
		</Fragment>
	)
}


export const FaAlertIcon = (props) => {
	return (
		<i style={{ fontSize: "25px", marginRight: "8px" }}
			className="fas fa-exclamation-triangle" />
	)
}

export const FaInfoCircle = (props) => {
	return (
		<i style={{ fontSize: "25px", marginRight: "10px" }}
			className="fa fa-info-circle" />
	)
}



export const _sha256 = (data) => {
	if (!Buffer.isBuffer(data)) throw new Error("_sha256(): data must be a Buffer")
	const bsvbuf = bsv.deps.Buffer.from(data)
	const hash = bsv.crypto.Hash.sha256(bsvbuf)
	const uint8arrayHash = new Uint8Array(hash)
	return bsv.deps.Buffer.from(uint8arrayHash)
}
export const script_to_scripthash = (script) => {
	return _sha256(new bsv.Script(script).toBuffer()).reverse().toString('hex')
}
export const address_to_script = (address) => {
	return bsv.Script.fromAddress(address).toHex()
}
export const scriptHex_to_address = (scriptHex) => {
	const script = bsv.Script.fromHex(scriptHex)
	return bsv.Address.fromScript(script).toString()
}
export const address_to_scripthash = (address) => {
	return script_to_scripthash(address_to_script(address))
}
export const pubkey_to_address = (pubkey) => {
	const log = getLog("pubkey_to_address(): with pubkey=" + pubkey + " : ")
	if (typeof pubkey !== 'string') throw new Error("pubkey_to_address(): pubkey must be a string")

	// // Convert the public key to a Buffer object
	// const pubKeyBuffer = Buffer.from(pubkey, 'hex')
	// return _sha256(pubKeyBuffer).toString('hex')

	// provided by chatGPT
	const publicKey = bsv.PublicKey.fromString(pubkey)
	// Create a new address from the public key object
	const address = bsv.Address.fromPublicKey(publicKey).toString()
	log("address=", address)
	// const hash = bsv.crypto.Hash.sha256(bsv.deps.Buffer.from(pubkey))
	// log("hash=", hash)
	return address

}
